import Realize from './realizejs/js/realize';

window.Realize = Realize;